// Template Generated by DataExtraction.py at 1716507313

import PQADEnglish from "../../Forms/PQAD/PQAD-English.png";
import PQADEnglishLabels from "../../Labels/PQAD/PQAD-English.json";
import PQADFrench from "../../Forms/PQAD/PQAD-French.png";
import PQADFrenchLabels from "../../Labels/PQAD/PQAD-French.json";
import {
    defaultFontSize,
    drawTextOnLabel,
    fillCheckboxAtLabel,
    standardFormAlias,
    standardFormCompression,
    isLanguageEnglish,
    standardFormFormat,
    standardFormHeight,
    standardFormWidth,
    standardFormX,
    standardFormY,
    signatureLabel,
    signatureTab
} from "../../PDFGenerationUtils";
import { POSSIBLE_SIGNERS } from "../../../Utils/PlanUtils";
import { t } from "i18next";

import moment from "moment/moment";

/*
 * @param doc {jsPDF}
 */
const generate = (doc, data, quote, authStatus, i18n) => {

    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? PQADFrenchLabels : PQADEnglishLabels;
    const formImage = isFrench ? PQADFrench : PQADEnglish;

    function fillCheckbox(value, label) {
        fillCheckboxAtLabel(doc, value, label, labels);
    }

    function drawText(value, label) {
        drawTextOnLabel(doc, value, label, labels);
    }

    function drawLongText(value, label) {
        drawTextOnLabel(doc, value, label, labels, null, false, true);
    }

    // add image
    doc.addImage(formImage, standardFormFormat, labels["image"]["x"], labels["image"]["y"], labels["image"]["width"], labels["image"]["height"], null, standardFormCompression);

    /* define state variables here ie:
     * const subscriber = data.subscriber;
     * const jointSubscriber = data.jointSubscriber;
     * const beneficiary = data.beneficiary;
    */

    const common = data.common;
    const subscriber = data.subscriber;
    const jointSubscriber = data.jointSubscriber;
    const now = moment().format("YYYY-MM-DD");
    const kyc = data.knowYourClient;


    // Drawing the form
    drawText(now, "drDate");
    if (data.drChecklist.howDidYouMeet == "Other") {
        drawText(data.drChecklist.howDidYouMeetDetails, "meetDR");
    } else {
        drawText(t(data.drChecklist.howDidYouMeet), "meetDR");
    }
    drawLongText(subscriber.employerAddress, "s1Address");
    drawText(now, "s1Date");
    drawText(subscriber.employer, "s1Employer");
    drawText(subscriber.firstName, "s1FirstName");
    drawText(subscriber.lastName, "s1LastName");
    drawText(subscriber.occupation, "s1Occupation");
    drawText(subscriber.employerIndustry, "s1Sector");

    if (common.subscriber2Include) {
        drawLongText(jointSubscriber.employerAddress, "s2Address");
        drawText(now, "s2Date");
        drawText(jointSubscriber.employer, "s2Employer");
        drawText(jointSubscriber.firstName, "s2FirstName");
        drawText(jointSubscriber.lastName, "s2LastName");
        drawText(jointSubscriber.occupation, "s2Occupation");
        drawText(jointSubscriber.employerIndustry, "s2Sector");
    }
}

//Returns the signature definitions for the document
// This includes who needs to sign and where
const signatureDefinitions = (state, documentId, pageNumber, i18n) => {
    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? PQADFrenchLabels : PQADEnglishLabels;
    const DRRecipientId = POSSIBLE_SIGNERS['Dealing Representative'];
    const subscriberRecipientId = POSSIBLE_SIGNERS['Subscriber'];
    const jointSubscriberRecipientId = POSSIBLE_SIGNERS['Joint Subscriber'];
    let signers = [];
    let signHereTabs = [];
    const subscriber2Include = state.common.subscriber2Include;


    // s1Signature
    signers.push({
        [subscriberRecipientId]: [signatureTab(subscriberRecipientId, documentId, pageNumber, signatureLabel("s1Signature", labels))],
    });

    if (subscriber2Include) {
        // s2Signature
        signers.push({
            [jointSubscriberRecipientId]: [signatureTab(jointSubscriberRecipientId, documentId, pageNumber, signatureLabel("s2Signature", labels))],
        });
    }


    // drSignature
    signers.push({
        [DRRecipientId]: [signatureTab(DRRecipientId, documentId, pageNumber, signatureLabel("drSignature", labels))],
    });


    return signers;
}

export default {
    generate,
    signatureDefinitions
}
